<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-05-16 16:08:04
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-05-18 11:30:11
 * @FilePath: \合联\oms\src\view\system\transportAirport\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
    ref="table">
  </cTable>
</template>

<script>
import cTable from '@/base/common/index';
import { apis } from '@/api/system/transportAirport.js'
export default {
  name: "transportAirport",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {
        add: {
          type: 'add',
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id })
              this.$page.handleRequestMethods('save', data, true, true).then(res => {
                this.$page.getList();
                close();
              })
            }
          },
          config: {
            title: this.$tz('新增'),
            modalBind: {
              width: 60
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: '20px'
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  message: 'cannot be empty',
                  trigger: 'blur',
                },
              ],
              warehouse_id: [
                {
                  required: true,
                  message: 'cannot be empty',
                  trigger: 'blur',
                  type: 'number'
                },
              ],
            }
          },
          grid: [
            { title: 24 },
            { warehouse_id: 24 },
            { outbound_status: 24 },
            { inbound_status: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$tz('机场名称'),
              key: 'title',
              component: 'Input',
              placeholder: () => this.$tz('机场名称'),
            },
            {
              name: this.$tz('仓库名称'),
              key: 'warehouse_id',
              component: 'Select',
              placeholder: () => this.$tz(''),
              options: [],
              optionsFn: 'getWarehouse',
              optionsKey: '',
              default: '',
            },
            {
              name: this.$tz('出库轨迹'),
              key: 'outbound_status',
              component: 'Select',
              placeholder: () => this.$tz('出库轨迹'),
              options: [],
              optionsFn: 'getTrackerStatus',
              optionsKey: '',
              default: '',
            },
            {
              name: this.$tz('到港轨迹'),
              key: 'inbound_status',
              component: 'Select',
              placeholder: () => this.$tz('到港轨迹'),
              options: [],
              optionsFn: 'getTrackerStatus',
              optionsKey: '',
              default: '',
            },
            {
              key: 'remarks',
              name: () => this.$tz('备注'),
              placeholder() {
                return this.$tz('备注');
              },
              component: 'Input',
              bind: {
                type: 'textarea',
                autosize: { minRows: 3 },
              },
            },

          ]
        },
      },
      header: {
        searchs: [
          {
            key: 'warehouse_id',
            placeholder() {
              return this.$tz('仓库名称')
            },
            component: 'Select',
            options: [],
            optionsFn: 'getWarehouse',
            optionsKey: '',
          },
          {
            key: 'keywords',
            placeholder() {
              return this.$t('keyword');
            },
            component: 'Input',
            bind: {
              type: 'textarea',
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz('导出'),
              type: 'export',
              fnName: 'export',
              bind: {
                type: 'primary'
              },
              disabled() {
                return !this.selectAll.length
              }
            },
            {
              name: () => this.$tz('新增'),
              type: 'add',
              fnName: 'add',
              bind: {
                type: 'primary'
              },
              id: 1670
            },
          ],
          methods: {
            add() {
              this.getModal('add').open({}, function () {
                this.setTitle(this.$tz('新增'))
              })
            },
            export() {
              this.exportExc()
            }
          }
        }
      },
      fields: [
        {
          type: 'checkbox',
          width: 50,
        },
        {
          name: () => this.$t("airport_name"),
          key: "title",
          minWidth: 130,
        },
        {
          name: () => this.$t("warehouseName2"),
          key: "warehouse",
          minWidth: 130,
        },
        {
          name: () => this.$t("Outgoing track"),
          key: "outbound_status",
          minWidth: 130,
        },
        {
          name: () => this.$t("Arrival track"),
          key: "inbound_status",
          minWidth: 130,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 130,
        },
        {
          name: () => this.$t("addTime"),
          key: "create_time",
          minWidth: 130,
        },
        {
          name: () => this.$t('operation'),
          type: 'btns',
          width: 220,
          fixed: 'right',
          list: [
            {
              name: this.$tz('更新'),
              type: 'update',
              fnName: 'update',
              bind: {
                type: 'primary'
              },
              id: 1670
            },
            {
              name: () => this.$tz('删除'),
              type: 'del',
              fnName: 'del',
              bind: {
                type: 'error'
              },
              id: 1671
            },
          ],
          methods: {
            update({ row }) {
              this.getModal('add').open(row, function (data) {
                this.setTitle(this.$tz('更新'))
              })
            },
            del({ row }) {
              this.$Modal.confirm({
                title: this.$tz('删除'),
                width: 300,
                content: this.$t('titleModal'),
                onOk: () => {
                  this.handleRequestMethods('delete', { id: row.id }, true, true).then(
                    res => {
                      this.getList()
                    }
                  );
                }
              })
            }
          }
        }
      ]
    }
  }
}
</script>

<style scoped></style>